<style lang="less" scoped>
  @import "../../vars.less";
  .button-container {
    padding: @space-normal;
    & > *:not(:last-child) {
      margin-bottom: @space-normal;
    }
  }
</style>

<template>
  <page-container class="customer-apply" :title="$t('申请SI客户')" :loading="loading">
    <van-form label-align="right" readonly>
      <van-field rows="1" autosize type="textarea"
        v-model="form.Name"
        name="Name"
        :label="$t('客户中文名称')" />
      <van-field rows="1" autosize type="textarea"
        v-model="form.EnName"
        name="EnName"
        :label="$t('客户英文名称')" />
      <picker readonly v-model="secretTypeCode" :label="$t('企业涉密类型')"
        value-field="Code" text-field="Name" :loading="secretTypeLoading"
        :columns="secretTypes" :placeholder="$t('请选择企业涉密类型')" />
      <picker readonly v-model="form.ProvinceName" :label="$t('省份')"
        value-field="Name" text-field="Name" :loading="provincesLoading"
        :columns="provinces" @change="onProvinceChange"
        :placeholder="$t('请选择省份')" />
      <picker readonly v-model="form.CityName" :label="$t('城市')"
        value-field="Name" text-field="Name" :loading="citiesLoading"
        :columns="cities" @change="onCityChange"
        :placeholder="$t('请选择城市')" />
      <picker readonly v-model="form.ZoneName" :label="$t('区县')"
        value-field="Name" text-field="Name" :loading="zonesLoading"
        :columns="zones" @change="onZoneChange"
        :placeholder="$t('请选择区县')" />
      <van-field v-model="form.PostCode" name="PostCode" type="number" :label="$t('邮编')"
        :placeholder="$t('请填写邮编')" />
      <van-field rows="1" autosize type="textarea"
        v-model="form.Address"
        name="Address"
        :label="$t('地址')" :placeholder="$t('请填写地址')" />
      <van-field v-model="form.USCCode" name="USCCode" :label="$t('统一信用代码')"
       :placeholder="$t('请填写统一信用代码')" />
      <!-- <van-field rows="1" autosize type="textarea"
        v-model="form.PrevNames"
        name="PrevNames" :placeholder="$t('请填写曾用名')"
        :label="$t('曾用名')" /> -->
    </van-form>
    <div class="button-container">
      <van-button block type="info" size="small" round @click="submit">{{$t('提交')}}</van-button>
    </div>
  </page-container>
</template>

<script>
import PageContainer from '../../components/PageContainer'
import Picker from '../../components/Picker.vue'
import { Form, Field, Button, Toast, Notify } from 'vant'

export default {
  name: 'customer-apply',
  components: {
    'van-form': Form,
    'van-field': Field,
    'van-button': Button,
    PageContainer,
    Picker
  },
  data () {
    return {
      form: {
        Name: this.$route.query.Name,
        EnName: '',
        PostCode: '',
        USCCode: '',
        PrevNames: '',
        Address: '',

        ProvinceName: '',
        CityName: '',
        ZoneName: '',
        SecretTypeName: ''
      },
      secretTypeCode: 'No',
      secretTypeLoading: false,
      secretTypeShow: false,
      secretTypes: [],

      provincesLoading: false,
      provincesShow: false,
      provinces: [],

      citiesLoading: false,
      citiesShow: false,
      cities: [],

      zonesLoading: false,
      zonesShow: false,
      zones: [],

      QCCInfo: {},

      loading: false
    }
  },
  methods: {
    getQCCInfo () {
      return this.$apis.customer.getQCCInfo(
        this.$route.query.Pkey,
        loading => (this.loading = loading)
      ).then(res => {
        if (!res) return
        this.QCCInfo = res
        this.form.EnName = res.EnName
        this.form.PostCode = res.PostCode
        this.form.USCCode = res.USCCode
        this.form.PrevNames = res.PrevNames
        this.form.Address = res.Address

        this.form.ProvinceName = res.QCCProvince
        this.form.CityName = res.QCCCity
        this.form.ZoneName = res.QCCZone
      })
    },
    getSecretTypes () {
      this.$apis.basic.getCustomerSecretTypes(() => {})
        .then(res => {
          if (res && res.length) {
            this.secretTypes = res
            this.secretTypeCode = res[0].Code
          }
        })
    },
    getProvinces () {
      return this.$apis.basic.getProvinces(
        loading => (this.provincesLoading = loading)
      ).then(res => {
        if (res) this.provinces = res
      })
    },
    getCities () {
      if (!this.form.ProvinceName) return Promise.resolve()
      let provinceCode = ''
      for (const p of this.provinces) {
        if (p.Name === this.form.ProvinceName) {
          provinceCode = p.Code
          break
        }
      }
      return this.$apis.basic.getCities(
        provinceCode,
        loading => (this.citiesLoading = loading)
      ).then(res => {
        if (res) this.cities = res
      })
    },
    getZones () {
      if (!this.form.CityName) return Promise.resolve()
      let cityCode = ''
      for (const c of this.cities) {
        if (c.Name === this.form.CityName) {
          cityCode = c.Code
          break
        }
      }
      this.$apis.basic.getZones(
        cityCode,
        loading => (this.zonesLoading = loading)
      ).then(res => {
        if (res) this.zones = res
      })
    },
    onProvinceChange () {
      this.form.CityName = ''
      this.form.ZoneName = ''
      this.form.PostCode = ''
      this.form.Address = ''
    },
    onCityChange () {
      this.form.ZoneName = ''
      this.form.PostCode = ''
      this.form.Address = ''
    },
    onZoneChange () {
      this.form.PostCode = ''
      this.form.Address = ''
    },
    submit () {
      if (!this.secretTypeCode) {
        Toast({
          message: this.$t('请选择企业涉密类型')
        })
      } else {
        // let SecretTypeName = ''
        // for (const t of this.secretTypes) {
        //   if (t.Code === this.form.secretTypeCode) {
        //     SecretTypeName = t.Name
        //     break
        //   }
        // }
        this.$apis.customer.createCustomer(
          // {
          //   ...this.QCCInfo,
          //   ...this.form,
          //   SecretTypeName
          // },
          {
            name: this.form.Name,
            USCCode: this.form.USCCode
          },
          loading => (this.loading = loading)
        ).then(res => {
          if (res) {
            // this.$router.push({ name: 'customer-list' })
            this.$back()
            Notify({ type: 'success', message: this.$t('新客户申请成功') })
          }
        })
      }
    }
  },
  mounted () {
    this.getQCCInfo().then(() => {
      this.getProvinces().then(() => {
        this.getCities().then(() => {
          this.getZones()
        })
      })
    })
    this.getSecretTypes()
  }
}
</script>
